import { render } from "./PublicationLoginSettingsCard.vue.js?vue&type=template&id=b553753e&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationLoginSettingsCard.vue?vue&type=template&id=b553753e&scoped=true"
import script from "./PublicationLoginSettingsCard.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationLoginSettingsCard.vue?vue&type=script&lang=js"
export * from "./PublicationLoginSettingsCard.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationLoginSettingsCard.vue?vue&type=script&lang=js"

import "./PublicationLoginSettingsCard.vue.css?vue&type=style&index=0&id=b553753e&scoped=true&lang=css!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationLoginSettingsCard.vue?vue&type=style&index=0&id=b553753e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b553753e"],['__file',"src/Web/scripts/components/publication/PublicationLoginSettingsCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b553753e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b553753e', __exports__)) {
    api.reload('b553753e', __exports__)
  }
  
  module.hot.accept("./PublicationLoginSettingsCard.vue.js?vue&type=template&id=b553753e&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationLoginSettingsCard.vue?vue&type=template&id=b553753e&scoped=true", () => {
    api.rerender('b553753e', render)
  })

}


export default __exports__